// Utility function to convert an image URL to a base64 string
// const proxyUrl = "https://cors-anywhere.herokuapp.com/";
const proxyUrl = "";
export const urlToBase64 = async (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // Allow cross-origin access
        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const base64String = canvas.toDataURL("image/png");
            resolve(base64String);
        };
        img.onerror = (err) => {
            reject(`Failed to load image at ${url}: ${err}`);
        };
        // img.src = url;
        img.src = `${proxyUrl}${url}`; // Fetch the image through the proxy
    });
};



export const isValidDomain = (domain) => {
    if (typeof domain !== 'string') return false;

    // Trim whitespace and convert to lowercase
    domain = domain.trim().toLowerCase();

    // Reject if protocol is included
    if (domain.startsWith('http://') || domain.startsWith('https://')) return false;

    // Reject if domain contains spaces or is too long
    if (domain.length > 253 || domain.includes(' ')) return false;

    // Valid domain regex (RFC 1035 compliant)
    const domainRegex = /^(?!-)(?:[a-z0-9-]{1,63}(?<!-)\.)+[a-z]{2,}$/;

    return domainRegex.test(domain);
}
